module.exports = __webpack_public_path__ + "img/banner_icon_4.54c6f264.jpg";